import { useState, useEffect } from "react";

export function useDomains() {
  const [domains, setDomains] = useState<{ id: string; name: string }[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchDomains = async () => {
    try {
      const response = await fetch("/api/auth/gsi/dominio");
      const data = await response.json();
      setDomains(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Erro ao buscar domínios:", error);
      setDomains([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDomains();
  }, []);

  return {
    domains,
    loading,
    refetch: fetchDomains,
  };
}
